import { Outlet, useLocation, useNavigate } from "react-router-dom";

import ProgressBar from "../ProgressBar/ProgressBar";
import Typography from "../Typography/Typography";
import styles from "./Navbar.module.scss";

import { ReactComponent as ArrowLeft } from "../../assets/arrowLeft.svg";

const Navbar = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const handleBackClick = () => {
		switch (pathname) {
			case "/register/validate-identity":
				navigate("/");
				break;

			case "/register/personal-data":
				navigate("/register/validate-identity");
				break;

			case "/register/last-steps":
				navigate("/register/personal-data");
				break;

			default:
				navigate();
				break;
		}
	};

	return (
		<div className={styles.navbarContainer}>
			<div className={styles.navbarTitleContainer}>
				<ArrowLeft
					className={styles.navbarTitleArrow}
					onClick={handleBackClick}
				/>

				<div
					className={styles.navbarTitleTxt}
					style={{ margin: "17px" }}
				>
					<Typography variant="h5">
						Únete a Amigos Juan Valdez
					</Typography>
				</div>
			</div>

			<div className={styles.navbarProgressBarContainer}>
				<ProgressBar></ProgressBar>
			</div>
			<Outlet />
		</div>
	);
};

export default Navbar;
